import { Injectable } from '@angular/core';

import { Observable, from } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';

import { HttpClient, HttpHeaders }  from "@angular/common/http";

import apiconfig from '../apiconfig';

@Injectable({
  providedIn: 'root'
})
export class CaptchaService {

  constructor(
    private http: HttpClient
  ) { }

  public checkCaptcha(response): Observable<any> {
    return from(
      this.http.post("https://gvmho9b9ob.execute-api.eu-west-1.amazonaws.com/test/facegatecaptcha", {body: response})
    ).pipe(
      tap(() => console.log("reCaptcha checked"))
    )
  }
  
}
